import { render, staticRenderFns } from "./AddProgram.vue?vue&type=template&id=3eabfb8c&scoped=true"
import script from "./AddProgram.vue?vue&type=script&lang=js"
export * from "./AddProgram.vue?vue&type=script&lang=js"
import style0 from "./AddProgram.vue?vue&type=style&index=0&id=3eabfb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eabfb8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VTextField,VTextarea})
